import React from 'react';
import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import cx from 'classnames';
import { Ellipsis } from '@common/components/Ellipsis';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { QuestionnaireListCompactDto } from '@common/dto/questionnaire/list-compact-dto';
import { Loading } from '@common/components/loading';

import "./questionnaires.styles.scss";
import { QUESTIONNAIRE_SELECTOR_ATTRIBUTE } from './questionnaires.constants';

// TODO use Questionnaires component from common, once it is in release branch

export type QuestionnairesProps = {
  disabled?: boolean;
  className?: string;
  loading: boolean;
  questionnaires: Array<QuestionnaireListCompactDto>;
  selectedQuestionnaire?: QuestionnaireListCompactDto;
  onSelectedQuestionnaireChange: (quest: QuestionnaireListCompactDto) => void;
  questionnairesRef: React.RefObject<HTMLDivElement>;
};

export const Questionnaires: React.FC<QuestionnairesProps> = (props) => {
  const { selectedQuestionnaire, onSelectedQuestionnaireChange, loading, questionnaires, className, disabled, questionnairesRef } = props;
  const localModuleName = `${MODULE_NAME}-questionnaires-list`;

  const columns = React.useMemo(
    () =>
      [
        { 
          name: (
            <Flex>
              {I18n.t('Questionnaire Name')} 
              {loading && questionnaires.length > 1 && <Loading size={16} margin="0 12px" />} 
            </Flex>
          ), 
          fieldName: "questionnaireName", 
          width: '100%' 
        },
      ].map((x) => ({ ...x, name: typeof x.name === 'string' ? I18n.t(x.name) : x.name })),
    [loading, questionnaires.length]
  );
  
  return (
    <div className={cx("FhqDesignToolQuestionnaires", { 'FhqDesignToolQuestionnaires--disabled': disabled, }, className)}>
      <Flex
        justify="space-between"
        alignItems="center"
        className="FhqDesignToolQuestionnaires__header"
      >
        {columns.map((x) => (
          <span key={x.fieldName} style={{ width: x.width }} className="FhqDesignToolQuestionnaires__header__cell">
            {x.name}
          </span>
        ))}
      </Flex>
      <div className="FhqDesignToolQuestionnaires__body" ref={questionnairesRef}>
        {loading && questionnaires.length === 0 && <Loading margin="40px" size={20} />}
        {questionnaires.map((item, i) => {
          const isSelected = item.questionnaireId === selectedQuestionnaire?.questionnaireId;
          
          return (
            <button
              key={item.questionnaireId}
              className={cx("FhqDesignToolQuestionnaires__body__row", { "FhqDesignToolQuestionnaires__body__row-selected": isSelected })}
              onClick={isSelected ? undefined : (() => onSelectedQuestionnaireChange(item))}
              {...{ [QUESTIONNAIRE_SELECTOR_ATTRIBUTE]: item.questionnaireId }}
              {...getTestAttributes(localModuleName, "item", "row")}
            >
              {columns.map((col, i) => {
                const isNameColumn = col.fieldName === 'questionnaireName';
                const imgWidth = 16;
                const imgMargin = 4;

                return (
                  <React.Fragment key={col.fieldName}>
                    {isNameColumn && <img src="gif/questionnaire.gif" style={{ marginRight: imgMargin, marginLeft: imgMargin }} width={imgWidth} />}
                    <Ellipsis 
                      className="FhqDesignToolQuestionnaires__body__row__cell" 
                      width={isNameColumn ? `calc(${col.width} - ${imgWidth + imgMargin * 2}px)` : col.width} 
                      text={(item as unknown as Record<string, string>)[col.fieldName]} 
                    />
                  </React.Fragment>
                );
              })}
            </button>
          );
        })}
      </div>
    </div>
  );
};